<script setup lang="ts">
import type { SearchFacetTuple } from '@@/types/search/types'

withDefaults(
  defineProps<{
    disabled?: boolean
    options?: {
      isActive?: boolean
      isNumber?: boolean
      label: string
      value: SearchFacetTuple
    }[]
    scrollable?: boolean
  }>(),
  {
    options: () => [],
    disabled: false,
    scrollable: false,
  },
)
defineEmits<{ select: SearchFacetTuple }>()
defineSlots<{ 'filter-button'(): any }>()
</script>

<template>
  <div :class="['-mx-2', { 'flex flex-nowrap overflow-auto': scrollable }]">
    <slot name="filter-button" />

    <button
      v-for="(option, i) in options"
      :key="`${option.label}-${i}`"
      :class="[
        'mx-2 mb-3 h-10 shrink-0 rounded-full border text-xs leading-none',
        { 'border-gray-700': !option.isActive && !disabled },
        {
          'border-transparent bg-gray-700 text-white':
            option.isActive && !disabled,
        },
        { 'cursor-wait border-gray-300 bg-gray-200': disabled },
        { 'px-4 py-3': !option.isNumber },
        { 'w-10 p-0': option.isNumber },
      ]"
      :disabled="disabled"
      type="button"
      @click="$emit('select', ...option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
